import React, { useState } from 'react';

import deleteIcon from 'images/icons/invite/delete.svg';
import Popup from 'components/Admin/Enterprises/Block/Popup';

import { useEnterpriseContext } from '../../../contexts/EnterpriseContext';

export default function DeleteAction({ enterpriseId, userToken }) {
  const [showBlockPopup, setShowBlockPopup] = useState(false);

  const { dispatch, actions } = useEnterpriseContext();

  const onBlockClicked = () => {
    document.querySelectorAll('.tooltip').forEach((el) => {
      el.remove();
    });
    setShowBlockPopup(true);
  };

  const onPopupClose = () => {
    setShowBlockPopup(false);
  };

  const onComplete = () => {
    actions.blockEnterprise(dispatch, enterpriseId);
  };

  return (
    <>
      <a
        data-tip="Block Enterprise"
        onClick={onBlockClicked}
      >
        <img src={deleteIcon} />
      </a>
      {showBlockPopup && (
      <Popup
        enterpriseId={enterpriseId}
        onHide={onPopupClose}
        userToken={userToken}
        onComplete={onComplete}
      />
      )}
    </>
  );
}
